"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Container_1 = require("../Container");

var Token_1 = require("../Token");
/**
 * Marks class as a service that can be injected using container.
 */


function Service(optionsOrServiceName, maybeFactory) {
  if (arguments.length === 2 || optionsOrServiceName instanceof Function) {
    var serviceId = {
      service: new Token_1.Token()
    };
    var dependencies_1 = arguments.length === 2 ? optionsOrServiceName : [];
    var factory_1 = arguments.length === 2 ? maybeFactory : optionsOrServiceName;
    Container_1.Container.set({
      id: serviceId.service,
      factory: function (container) {
        var params = dependencies_1.map(function (dependency) {
          return container.get(dependency);
        });
        return factory_1.apply(void 0, params);
      }
    });
    return serviceId;
  } else {
    return function (target) {
      var service = {
        type: target
      };

      if (typeof optionsOrServiceName === "string" || optionsOrServiceName instanceof Token_1.Token) {
        service.id = optionsOrServiceName;
        service.multiple = optionsOrServiceName.multiple;
        service.global = optionsOrServiceName.global || false;
        service.transient = optionsOrServiceName.transient;
      } else if (optionsOrServiceName) {
        // ServiceOptions
        service.id = optionsOrServiceName.id;
        service.factory = optionsOrServiceName.factory;
        service.multiple = optionsOrServiceName.multiple;
        service.global = optionsOrServiceName.global || false;
        service.transient = optionsOrServiceName.transient;
      }

      Container_1.Container.set(service);
    };
  }
}

exports.Service = Service;